import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getSubmitVerificationInformationCTA } from "./shared";

export const VerificationStatusIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getSubmitVerificationInformationCTA(context, strictLocalize)
          ?.label;
      },
      linkBuilder: (context) => {
        return getSubmitVerificationInformationCTA(
          context,
          strictLocalize
        )?.getLink?.();
      },
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => VERIFICATION_STATUS_TITLE(strictLocalize),
    getDescription: () => [
      VERIFICATION_STATUS_DESCRIPTION_1(strictLocalize),
      VERIFICATION_STATUS_DESCRIPTION_2(strictLocalize),
    ],
  };
};

const VERIFICATION_STATUS_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Account verification status",
    description: {
      text: "Title for the answer of submitting additional information for account verification",
    },
  });

const VERIFICATION_STATUS_DESCRIPTION_1 = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "If you have submitted all the necessary information, please allow 2-3 business days for our team to review the information.",
  });

const VERIFICATION_STATUS_DESCRIPTION_2 = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "To submit additional information, please contact us.",
  });
